"use client";

import type { FeedItems } from "../../../types/content/feedItem";

import { isArticleFeedItem, isInjectable } from "../../../utils/typechecks";
import { InjectablePlaceholder } from "../../Injectable/Injectable";
import { LatestNewsArticleCluster } from "./LatestNewsArticleCluster/LatestNewsArticleCluster";
import { LatestNewsBoxCluster } from "./LatestNewsBoxCluster/LatestNewsBoxCluster";

const LatestNewsLayout = ({
  data,
  isFirstFeed,
  isLoggedIn,
}: {
  data: FeedItems;
  isFirstFeed?: boolean;
  isLoggedIn?: boolean;
}) => {
  return (
    <div>
      {data.map((feedItem, clusterIndex) => {
        if (!feedItem) return null;

        if (isInjectable(feedItem)) {
          return (
            <InjectablePlaceholder
              resource={feedItem}
              key={`${feedItem.type}${clusterIndex}`}
            />
          );
        }

        const isLastElement = data.length === clusterIndex + 1;
        const isFirstElement = clusterIndex === 0;
        const hasBoxAfter = data?.[clusterIndex + 1]?.type === "Box";
        const hasBoxBefore = data?.[clusterIndex - 1]?.type === "Box";

        const teaserWeight = feedItem.weight;

        if (feedItem.type === "Box") {
          return (
            <LatestNewsBoxCluster
              boxGroup={feedItem}
              positionInFeed={clusterIndex + 1}
              key={`${feedItem.id}${clusterIndex}`}
              teaserWeight={teaserWeight}
            />
          );
        }

        if (isArticleFeedItem(feedItem)) {
          const shouldPrioritizeImageLoad = clusterIndex > 3 && isFirstFeed;
          return (
            <LatestNewsArticleCluster
              feedItem={feedItem}
              isLoggedIn={isLoggedIn}
              shouldPrioritizeImageLoad={shouldPrioritizeImageLoad}
              isLastElement={isLastElement || hasBoxAfter}
              isFirstElement={isFirstElement || hasBoxBefore}
              key={`${feedItem.id}${clusterIndex}`}
              positionInFeed={clusterIndex + 1}
              teaserWeight={teaserWeight}
            />
          );
        }
      })}
    </div>
  );
};

export { LatestNewsLayout };
